export default __webpack_public_path__ + "static/media/img-hero-mobile-02-organic.1d21a458.jpg";